import { Component, OnInit } from '@angular/core';
import { EditJobPostModel } from "../../../models/inModels/JobPost";
import { Message } from "primeng/components/common/message";
import { SelectItem } from "primeng/components/common/selectitem";
import { BusinessService } from "../../../services/business/business-category.service";
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { JobPostService } from "../../../services/business/job-post.service";

@Component({
	selector: 'app-job-posts-edit',
	templateUrl: './job-posts-edit.component.html',
	styleUrls: ['./job-posts-edit.component.css']
})
export class JobPostsEditComponent implements OnInit {
	id;
	model: EditJobPostModel;
	loading = false;
	error: Message[];
	categories: SelectItem[];
	selectedCategory;
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private service: JobPostService,
		private businessService: BusinessService) {
		this.id = this.route.snapshot.paramMap.get('Id');
	}

	ngOnInit() {
		this.getJobPost();
	}

	getJobPost() {
		this.loading = true;
		this.service.get(this.id).then(
			result => {
				this.model = new EditJobPostModel(result);
				this.selectedCategory = { value: result.BusinessCategoryId, label: result.BusinessCategory };
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	initCategoryDropDown(event) {
		this.businessService.getDropdown(event).then(
			x => {
				this.categories = x;
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	setCategory(): void {
		this.model.businessCategoryId = this.selectedCategory.value;
	}

	goBack(): void {
		this.router.navigate(['/jobposts']);
	}

	save() {
		this.loading = true;
		this.service.update(this.model).then(
			result => {
				this.loading = false;
				this.model = new EditJobPostModel(result);
				this.error = [];
				this.error.push({ severity: 'success', summary: 'Success', detail: "JobPost saved" });
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/job-posts/job-posts-edit/job-posts-edit.component.ts